/* eslint-disable react/require-default-props */
import theme from "@config/theme";
import { AspectRatioBox } from "./AspectRatioBox";

interface Props {
  children?: React.ReactNode;
  heightPx?: number;
  widthPx?: number;
  youtubeEmbedUrl?: string;
}

const VideoBox = ({ children, heightPx, widthPx, youtubeEmbedUrl }: Props) => {
  const aspectRatioProps = {
    children: youtubeEmbedUrl ? (
      <iframe
        src={youtubeEmbedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture web-share"
        allowFullScreen
      />
    ) : (
      children
    ),
    heightPx: heightPx || 315,
    widthPx: widthPx || 560,
    className: "video-box",
  };

  return (
    <>
      <AspectRatioBox {...aspectRatioProps} />
      <style jsx>{`
        :global(.video-box) {
          margin: 1rem 0;
          border-radius: 12px;
          /* Limit the size of the responsive video on large screens */
          max-height: 300px;
          /* To maintain the aspect ratio of the video */
          width: 100%;
        }

        @media only screen and (max-width: ${theme.breakpoints.md}px) {
          :global(.video-box) {
            max-height: inherit;
            margin: 2rem 0 1rem 0;
          }
        }
      `}</style>
    </>
  );
};

export { VideoBox };
